import React, { Component } from 'react';
import { firebase, firebaseListToArray } from '../utils/firebase';
import { hashHistory } from 'react-router';
import { defaultshow } from './DefaultGig';
import { sortByTime } from '../js/sortByTime.js';
import { filterBySets } from '../js/filterBySets.js';
import MakeSets from './MakeSets';
import DefaultSongs from './DefaultSongs';
import moment from 'moment';
import jQuery from 'jquery';
import SongButton from './SongButton';
import SubmitModal from './SubmitModal';

class GigForm extends Component {
  constructor(props){
    super(props);
    this.state={
      uid:0,
      genres:[],
      gig:{},
      show:false,
      submitted:false,
      method:'auto',
      song_list:[]
    }
  }
  componentWillMount(){
  //
    firebase.auth().onAuthStateChanged(
      user => {
        let uid=0;

        if(user){
        // console.log('uid: ',user.uid);
          this.setState({
            uid:user.uid
          });
          uid=user.uid;
          firebase.database()
          .ref('/'+uid+'/songs')
          .on('value',(data)=>{
            let snapshot = data.val();
            let songs = firebaseListToArray(snapshot);
            console.log('songs in form cwm: ',songs);
            this.setState({
              songs:songs
            });
          // console.log('the Dash CWM songs: ',this.state.songs);
          });
          return;
        }
        let songsobj = DefaultSongs.songs;
        let songs = firebaseListToArray(songsobj);
        console.log('songs in cwm: ',songs);
        this.setState({
          songs:songs
        });
      }
    );
  }

  //=====================GIG CREATION FUNCTIONS==========================


  shuffle(array){
   var currentIndex = array.length, temporaryValue, randomIndex;

   // While there remain elements to shuffle...
   while (0 !== currentIndex) {

     // Pick a remaining element...
     randomIndex = Math.floor(Math.random() * currentIndex);
     currentIndex -= 1;

     // And swap it with the current element.
     temporaryValue = array[currentIndex];
     array[currentIndex] = array[randomIndex];
     array[randomIndex] = temporaryValue;
   }

   return array;
 }


  filterByMood(songs,feels){
     this.shuffle(songs);
     let vibes = feels;
     let results = [];
     function compare(vibes,moods,song){
       for(let n=0; n<vibes.length; n++){
         //to each mood in song:
         for(let i=0; i<moods.length; i++){
           //add the song to results if its mood matches
           if(moods[i]===vibes[n]){
             results.push(song);
             return null;
           }
         }
       }
     }
     //go through each song:
     songs.forEach((val) =>{
       compare(feels,val.moods,val);
     });
    //  console.log('results',results);
     return results;
   }

   //=====================GIG GENERATION FUNCTIONS==========================

   makeSets(gigtitle,max,genresdesired,setsdesired){
     console.log('lean function');
     this.updateGig(gigtitle,max,genresdesired,setsdesired);
   }
   updateGig(title,minutes,genres,sets){
     let moodfiltered = this.filterByMood(this.state.songs,genres);
    //  console.log('after mood filter:',moodfiltered);
     let timefiltered = sortByTime(moodfiltered,minutes);
    //  console.log('after time filter: ',timefiltered);
     let setfiltered;
     filterBySets(timefiltered,sets).then((output)=>{
       console.log('output -- ',output);
       this.setState({
         gigtime:output.final,
         gigmillisecs:output.total
       });
       setfiltered = output.results;

       console.log('after set filter-- ',setfiltered);
       let newgig={
         title:title,
         genres:genres,
         sets:setfiltered,
         setnum:sets,
         maxminutes:minutes
       };
       this.setState({
         gig:newgig
       }),
       this.previewGig();
     });
   }
   previewGig(){
     console.log('current gig: ',this.state.gig);
     this.setState({
       show:true
     });
   }
   submitGig(e){
     e.preventDefault();
     let uid = this.state.uid;
     console.log('unlogged in: ',uid);
     console.log('gig to firebase: ',this.state.gig);
    let gig=this.state.gig;

    // if no user signed in:
    if(uid===0){
      this.setState({
        submitted:true,
        modaltext:'You gotta log in first.',
        gig:{},
        gigtime:''
      });
      return;
    }
    // if form not filled:
    if(
      (this.state.method=='auto') &&
      (!gig.hasOwnProperty('title') ||
      !gig.hasOwnProperty('maxminutes') ||
      !gig.hasOwnProperty('sets') ||
      !gig.hasOwnProperty('genres') ||
      gig.title=='' ||
      gig.maxminutes=='' ||
      gig.sets==[] ||
      gig.genres==[])
    ){
      this.setState({
        submitted:true,
        modaltext:'Finish the gig, baby.'
      });
      return;
    }
    gig.time=this.state.gigmillisecs || 0;
     firebase.database()
     .ref('/'+uid+'/gigs')
     .push({
       gig:gig
     });
     this.setState({
       submitted:true,
       modaltext:'Yeaah.',
       gig:{},
       gigtime:''
     });
     jQuery('.form-control').val('');
   }
   //==============================FORM FUNCTIONS=================

   goBack(e){
     e.preventDefault();
     hashHistory.goBack();
   }

   hideModal(){
     this.setState({
       submitted:false
     });
   }

   //========================GIG RENDER FUNCTIONS===================
   constructSets(maxsets,sets,setnum,frame){
     let songs = [];
     let uid = this.state.uid;
     for(let i=0; i<sets.length; i++){
       let id = sets[i].id;
       console.log('yo baby - ',id, ' frame - ',frame);
       firebase.database()
       .ref(uid+'/songs/'+id)
       .on('value',(data)=>{
         let result=data.val();
         result.id=id;
         songs.push(result);
         console.log('SONGS:',songs);
       });
     }
     if(songs.length==0){
       let defaultsongs = DefaultSongs.songs;
       for(let i=0; i<sets.length; i++){
         let id = sets[i].id;
         firebase.database()
         .ref(uid+'/songs/'+id)
         .on('value',(data)=>{
           let result=data.val();
           result.id=id;
           songs.push(result);
         });
         songs.push(defaultsongs[id]);
       }
     }
     console.log('the songs are: ',songs);
     //go through for each set:
     for(let x=0; x<maxsets; x++){
       let  goods=[];
       // go through every song in the gig:
       for (var song =0; song<sets.length; song++) {
         if (sets.hasOwnProperty(song)) {
         // check if song has current gig number
         let tune=[];
           if(this.state.method==='auto' && sets[song].set===setnum){
             //grab the matching song from our updated array 'songs'
             for(let i=0; i<songs.length; i++){
               if(songs[i].id===sets[song].id){
                 tune = songs[i];
                 console.log('the auto tune is: ',tune);
               }
             }
             //create the JSX for that set
             goods.push(<li>{tune.title}</li>);
           }else if(this.state.method==='manual'){
             frame=[];
             //manually enter every song chosen by user:
             console.log('manual sets: ',sets);
             tune = sets[song];
             console.log('the tune is: ',tune.title);
             //create the JSX for that set
             goods.push(<li>{tune.title}</li>);
           }
         }
       }
       frame.push(
         <div>
           <h3>Set {setnum}</h3>
           <ul>
             {goods}
           </ul>
         </div>
       );
       //increase the set number
       setnum++;
     }
     return frame;
   }
   manuallyMakeSets(id){
     var song_id = id || 'none';
     console.log('manual id: ',song_id);
     let gigtitle = this.refs.gigtitle.value;
     let max=15000;
     let setsdesired=1;
    //  if(song_id=='rabbit'){
    //    console.log('nooo');
    //    let newgig= (this.state.gig.sets) ? this.state.gig : {
    //      title:this.refs.gigtitle.value,
    //      sets:[],
    //      setnum:setsdesired,
    //      maxminutes:max
    //    };
    //    this.setState({
    //      gig:newgig
    //    }),
    //    this.previewGig();
    //    return;
    //  }
    let song_list = this.state.song_list;
    if(song_id !=='none'){
     let new_song = (song_id) ? this.state.songs.filter((song)=>{
       return song.id === song_id;
     })[0] : '';
     song_list = this.state.song_list.map((song)=>{
       return song;
     });
     song_list.push(new_song);
     console.log('song_list: ',song_list);
     this.setState({
       song_list
     });
   }
    let newgig={
      title:gigtitle,
      sets:song_list,
      setnum:1,
      maxminutes:max
    };
    console.log('newgig: ',newgig);
    this.setState({
      gig:newgig
    }),
    this.previewGig();

   }
   gigInfo(frame){
     return (this.state.show || this.state.method=='manual') ? (
       <div className="gig-info">
         <div className="gig-preview-header">
           <div className="gig-preview-title">{this.state.gig.title}</div>
           <div className="gig-est-time">{this.state.gigtime || 'na'}</div>
         </div>
         <ul dropzone="copy">
           { frame }
         </ul>
       </div>
     ) :
     (
       <div className="gig-info">
         <div className="gig-preview-header">
           <div dropzone="copy" className="gig-preview-instructions">SmartSet will automatically compile the perfect gig from your database of songs.</div>
         </div>
         <ul>
           { frame }
         </ul>
       </div>
     );
   }
  onDrop(data) {
      console.log(data)
      // => banana
  }
  toggleAuto(e){
    e.preventDefault();
    const id=e.target.id;
    console.log(id);
    this.setState({
      method:id
    });
  }
  toSonglist(e){
    e.preventDefault();
    console.log('adding ',e.target.value);
    // const val = e.target.value;
    // const id = this.refs[val].id;
    const id = e.target.id;
    console.log('adding id: ',id);
    this.manuallyMakeSets(id);
  }
  render(){
    let submitModal = (this.state.submitted) ? (<SubmitModal text={this.state.modaltext} hide={this.hideModal.bind(this)}/>) : '';
    const songs = (this.state.songs) ? this.state.songs.map(song => {
      return <SongButton songObject={ song } />
    }) : '';
    let frame=[];
    let maxsets = parseInt(this.state.gig.setnum);
    let setnum=1;
    let sets = this.state.gig.sets
    console.log('sets are: ',sets);
    if(sets){
      frame = this.constructSets(maxsets,sets,setnum,frame);
    }
    console.log('the time of gig: ',this.state.gigtime, 'frame: ',frame);
    const gigInfo = this.gigInfo(frame);
    const user_songs = (this.state.songs) ? this.state.songs.sort(
      function(item,item2){
        let title1 = item.title.toUpperCase();
        let title2 = item2.title.toUpperCase();
        if (title1 < title2) {
          return -1;
        }
        if (title1 > title2) {
          return 1;
        }
        return 0;
      }
    ).map((tune)=>{
      return (
        <li className="tune-choice" ref={tune.title} id={tune.id} onClick={this.toSonglist.bind(this)}>
          {tune.title}
        </li>
      );
    }) : '';
    const makeSets = (this.state.method==='auto') ? (<MakeSets makeSets={this.updateGig.bind(this)} /> ) : (
        <div className="form-group">
        <label for="title-input">Gig Name</label>
        <input onKeyUp={()=>this.manuallyMakeSets()} id="title-input" ref="gigtitle" type="text" className="form-control">
        </input>
        <div>
          <ul>
            {user_songs}
          </ul>
        </div>
        {/* <label for="lyrics-input">Songs</label>
        {songs} */}
      </div>
    )
    return(
      <div className="wrapper container landed_content">
        <div className="row">
            <div className="gig-form-container col-sm-6">
              <form className="gig-form form form-default" action="#" >
                <h2>Create a Gig</h2>
                <div>
                  <div onClick={this.toggleAuto.bind(this)} id="manual" className="btn btn-primary">Manual</div>
                  <div onClick={this.toggleAuto.bind(this)} id="auto" className="btn btn-primary">Auto</div>
                </div>
                <div>


              </div>


                { makeSets }

                <div className="form-group submit-buttons">
                  {/* <button type="submit" onClick={ this.makeSets.bind(this) } className="btn btn btn-primary">Preview</button> */}
                  <button type="submit" onClick={ this.submitGig.bind(this) } className="btn btn-primary">Submit</button>
                  <button type="submit" onClick={ this.goBack.bind(this) } className="btn btn-primary">Go Back</button>
                </div>
              </form>
            </div>
            <div className="gig-preview col-sm-6">
              <div droppable="true" className="gig-cover"></div>
              { gigInfo }
            </div>
        </div>
        {submitModal}
      </div>
    );
  }
}


export default GigForm;



// WEBPACK FOOTER //
// ./src/components/GigForm.js